import { render, staticRenderFns } from "./card-media-slider.vue?vue&type=template&id=70e19c68&scoped=true&"
import script from "./card-media-slider.vue?vue&type=script&lang=js&"
export * from "./card-media-slider.vue?vue&type=script&lang=js&"
import style0 from "./card-media-slider.vue?vue&type=style&index=0&id=70e19c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e19c68",
  null
  
)

export default component.exports